const baseUrl =  process.env.NODE_ENV === "development" ? `${process.env.REACT_APP_API_URL_DEV}` : `${process.env.REACT_APP_API_URL}`;


module.exports = {
  baseUrl
}